import Vue from 'vue'
import VueRouter from 'vue-router'
import ChatPage from '@/views/ChatPage.vue'
import LoginPage from '@/views/LoginPage.vue'
import CallbackPage from '@/views/CallbackPage.vue'
import { authService } from '@/services/AuthService'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/',
    name: 'Home',
    component: ChatPage,
    meta: {requiresAuth: true}
  },
  {
    path: '/chat/:conversationId',
    name: 'Chat',
    component: ChatPage,
    props: true,
    meta: {requiresAuth: true}
  },
  {
    path: '/callback',
    name: 'Callback',
    component: CallbackPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const accessToken = authService.getAccessToken();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  
  if (requiresAuth && !accessToken) {
    // Redirect to callback if route requires auth but no token
    next('/callback');
  } else {
    next();
  }
});

export default router
